import { useQualityMetricsManagementContext } from '../quality-metrics-management.context';
import styles from '../quality-metrics-management.module.scss';

function Section({ title, text, emptyText }) {
  return (
    <>
      <h3 className={styles.sectionTitle}>{title}</h3>
      <p className={text ? styles.sectionText : styles.emptyText}>{text || emptyText}</p>
    </>
  );
}

/**
 * Numerator / denominator / compliance. The clinician tab hides whichever of
 * these is blank; here a blank one is shown as empty, because "nobody has
 * written the denominator yet" is the thing an admin needs to notice.
 */
export function ManagementDefinitionTab() {
  const { selectedMetric, lang, metricLang } = useQualityMetricsManagementContext();

  return (
    <div className={styles.definitionTab}>
      <Section
        title={metricLang.NUMERATOR}
        text={selectedMetric.numerator}
        emptyText={lang.NOT_SET}
      />
      <Section
        title={metricLang.DENOMINATOR}
        text={selectedMetric.denominator}
        emptyText={lang.NOT_SET}
      />
      <Section
        title={metricLang.COMPLIANCE}
        text={selectedMetric.compliance}
        emptyText={lang.NOT_SET}
      />
      <Section
        title={metricLang.DEFINITION}
        text={selectedMetric.description}
        emptyText={lang.NOT_SET}
      />
    </div>
  );
}
